import { TCreateSendLinkSettingsPatch } from '../../../types/createSendLinkSettings';
import { IOneLinkRecipients, TOneLinkRecipient } from '../../../types/oneLink';

export const PATCH_CS_LINK_SETTINGS = 'PATCH_CS_LINK_SETTINGS';
export const CS_UPLOAD_2FA_RECIPIENTS = 'CS_UPLOAD_2FA_RECIPIENTS';
export const CS_ADD_ALLOWED_RECIPIENT = 'CS_ADD_ALLOWED_RECIPIENT';
export const CS_EDIT_ALLOWED_RECIPIENT = 'CS_EDIT_ALLOWED_RECIPIENT';
export const CS_DELETE_ALLOWED_RECIPIENT = 'CS_DELETE_ALLOWED_RECIPIENT';
export const CS_DELETE_ALL_ALLOWED_RECIPIENTS = 'CS_DELETE_ALL_ALLOWED_RECIPIENTS';

export const patchCsLinkSettings = (payload: TCreateSendLinkSettingsPatch) => ({
  type: PATCH_CS_LINK_SETTINGS,
  payload,
});

export const csUpload2FARecipients = (payload: IOneLinkRecipients) => ({
  type: CS_UPLOAD_2FA_RECIPIENTS,
  payload,
});

export const csAddAllowedRecipient = (payload: TOneLinkRecipient) => ({
  type: CS_ADD_ALLOWED_RECIPIENT,
  payload,
});

export const csEditAllowedRecipient = (payload: TOneLinkRecipient) => ({
  type: CS_EDIT_ALLOWED_RECIPIENT,
  payload,
});

export const csDeleteAllowedRecipient = (payload: string) => ({
  type: CS_DELETE_ALLOWED_RECIPIENT,
  payload,
});

export const csDeleteAllAllowedRecipients = () => ({
  type: CS_DELETE_ALL_ALLOWED_RECIPIENTS,
});
